import { useEffect } from 'react';

import useCustomLogin from '../hook/useLogin';
import SplashScreen from './SplashScreen';

const GuestSplashScreen = () => {
  const { guestLogin } = useCustomLogin();

  useEffect(() => {
    guestLogin();
  }, []);

  return <SplashScreen />;
};

export default GuestSplashScreen;
